module.exports = {"330203001":"南门街道","330203002":"江厦街道","330203003":"西门街道","330203004":"月湖街道","330203005":"鼓楼街道","330203006":"白云街道","330203007":"段塘街道","330203008":"望春街道","330203009":"石碶街道","330203100":"高桥镇","330203101":"横街镇","330203102":"集士港镇","330203103":"古林镇","330203104":"洞桥镇","330203105":"鄞江镇","330203106":"章水镇","330203200":"龙观乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330203.json
// module id = 955
// module chunks = 0